// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__28brt","rootSmall":"AddTileButton_rootSmall__TWXav"};